import React, { useRef, useEffect, useState } from 'react'

import './styles.scss'

// https://www.pinterest.com/pin/231513237070538877/

const Circle = ({menly}: {menly: number}) => 
{
  return (
    <span className='circle'>
      <span className='w'></span>
      <span className='m' style={{width: `${menly * 100}%`}}></span>
    </span>
  )
}

const Row = ({m, w}: {m: number, w: number}) => {

  // This array gets an entry for each circle how "menly" it is (1 = full men, 0 = ... you know...)
  const menlyarray:Array<number> = []

  // Loop "m"s
  for(let i = 1; i <= Math.ceil(m); i++)
  {

    if(i <= m) menlyarray.push(1)
    else menlyarray.push(m % 1)
  }

  // Loop "w"
  for(let i = 0; i < Math.floor(w); i++)
  {
    menlyarray.push(0)
  }

  return (

    <div className='content'>
      {menlyarray.map((e, i) => <Circle menly={e} key={i}/>)}
    </div>
  )
}

export const SexGraph = ({ 
  data,
}: {
  data: Array<any>,
}) => {


  const kings = data.executives.filter(e => e.sex === 'm').length;
  const queens = data.executives.filter(e => e.sex === 'w').length;

  const m = (kings + queens) / 100 * data.gender.m;
  const w = (kings + queens) / 100 * data.gender.w;

  return (
    <div className='sexgraph'>
      
        <div className='legend'>
          <div className='circle men' />&nbsp;Männer
          <div className='circle women' />&nbsp;Frauen
        </div>
      
        <div className='title'>
          Im Rat
        </div>
        <div className='subtitle'>
          {kings} / {queens}
        </div>
        <div className='graph'>
          <Row
            m={kings}
            w={queens}
          />
        </div>
      
        <div className='title'>
          In der Bevölkerung
        </div>
        <div className='subtitle'>
          {data.gender.m} / {data.gender.w}%
        </div>
        <div className='graph'>
          <Row
            m={m}
            w={w}
          />
        </div>

    </div>
  )
}
